import { call, put, select } from 'redux-saga/effects';

import { goToDiagramsService } from './router';
import {
  createDiagramItemRequest,
  deleteDiagramItemRequest,
  updateDiagramItemRequest,
  fetchDiagramRequest,
} from '../requests';
import { pathSelector } from '../../../selectors';
import {
  createDiagramItem,
  deleteDiagramItem,
  updateDiagramItem,
  updateDiagramItemReceived,
  deleteDiagramItemReceived,
} from '../../../actions';

export function* fetchDiagramService(factoryId) {
  yield call(fetchDiagramRequest, factoryId);
}

export function* createDiagramItemService(data) {
  yield put(createDiagramItem(data));

  yield call(createDiagramItemRequest, data);
}

export function* updateDiagramItemService(id, data) {
  yield put(updateDiagramItem(id, data));
  yield call(updateDiagramItemRequest, id, data);
}

export function* deleteDiagramItemService(id) {
  const { diagramId } = yield select(pathSelector);

  if (id === diagramId) {
    yield call(goToDiagramsService);
  }

  yield put(deleteDiagramItem(id));
  yield call(deleteDiagramItemRequest, id);
}

export function* updateDiagramItemReceivedService(data) {
  yield put(updateDiagramItemReceived(data));
}

export function* deleteDiagramItemReceivedService(id) {
  yield put(deleteDiagramItemReceived(id));
}
